import React, { Component } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { Link, withRouter } from "react-router-dom";

class NakireSGTSidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
    };
  }

  render() {
    if (this.state.user.role_id <= 3) {
      return (
        <React.Fragment>
          <li className="menu-title">{this.props.t("Nakire SGT")}</li>
          <li>
            <Link to="dashboard" className="waves-effect">
              <i className="bx bxs-dashboard"></i>
              <span>{this.props.t("Cuadro de mandos")}</span>
            </Link>
          </li>

          <li>
            <Link to="/#" className="waves-effect">
              <i className="bx bx-task"></i>
              <span>{this.props.t("Tareas")}</span>
            </Link>

            <ul className="sub-menu" aria-expanded="false">
              <li>
                <Link to="/tasks">
                  <i className="mdi mdi-subdirectory-arrow-right" />
                  {this.props.t("Tareas")}
                </Link>
              </li>
              <li>
                <Link to="/tasksWorkStations">
                  <i className="mdi mdi-subdirectory-arrow-right" />
                  {this.props.t("Estaciones de trabajo")}
                </Link>
              </li>
            </ul>
          </li>

          <li>
            <Link to="/racks" className="waves-effect">
              <i className="mdi mdi-billiards-rack"></i>
              <span>{this.props.t("Racks")}</span>
            </Link>
          </li>

          <li>
            <Link to="/#" className="waves-effect">
              <i className="bx bxs-ruler"></i>
              <span>{this.props.t("Estaciones de trabajo")}</span>
            </Link>

            <ul className="sub-menu" aria-expanded="false">
              {this.state.user.role_id < 3 && (
                <li>
                  <Link to="/workstations">
                    <i className="mdi mdi-subdirectory-arrow-right" />
                    {this.props.t("Estaciones de trabajo")}
                  </Link>
                </li>
              )}
              <li>
                <Link to="/workstations-positions">
                  <i className="mdi mdi-subdirectory-arrow-right" />
                  {this.props.t("Posiciones")}
                </Link>
              </li>
            </ul>
          </li>

          <li>
            <Link to="mapa" className="waves-effect">
              <i className="bx bx-map-alt"></i>
              <span>{this.props.t("Mapa")}</span>
            </Link>
          </li>

          <li>
            <Link to="alertas" className="waves-effect">
              <i className="bx bx-alarm"></i>
              <span>{this.props.t("Alertas")}</span>
            </Link>
          </li>
        </React.Fragment>
      );
    } else {
      return null;
    }
  }
}

export default withRouter(withNamespaces()(NakireSGTSidebarContent));
